/**
 * 内置头像预设.
 *
 * 头像不是图片文件, 而是"主题语义色底 + 人形图标"的组合:
 * 底色取自当前主题的语义色 (primary/secondary/accent/info/success/neutral),
 * 因此会跟随主题切换 (light / dark 都是同一套 Claude 语义色, 珊瑚橘为主), 不需要为每个主题准备素材。
 *
 * - 后端只校验格式 ^avatar-\d{2}$, 所以标识符保持不变;
 * - 文字/图标色用对应的 *-content token, 对比度由主题保证。
 */

export const AVATAR_OPTIONS: readonly string[] = [
  'avatar-01',
  'avatar-02',
  'avatar-03',
  'avatar-04',
  'avatar-05',
  'avatar-06',
]

const AVATAR_CLASSES: readonly string[] = [
  'bg-primary text-primary-content',
  'bg-secondary text-secondary-content',
  'bg-accent text-accent-content',
  'bg-info text-info-content',
  'bg-success text-success-content',
  'bg-neutral text-neutral-content',
]

/** 头像标识 → Tailwind 底色/前景类 (未知标识回退到第一个预设) */
export function avatarClass(name: string | undefined): string {
  const index = name ? AVATAR_OPTIONS.indexOf(name) : 0
  if (index <= 0) return AVATAR_CLASSES[0] ?? 'bg-primary text-primary-content'
  return AVATAR_CLASSES[index] ?? AVATAR_CLASSES[0] ?? 'bg-primary text-primary-content'
}
